import useAuthProfile, { AuthProfile } from 'shared/features/auth/authentication/providers/states/auth-profile';

export type AuthProviderState = AuthProfile;

const useAuthProviderState = (): AuthProviderState => {
  const authProfile = useAuthProfile();
  return { ...authProfile };
};

export default useAuthProviderState;
